import React, { useState, useRef } from "react";

// services
import { Mixpanel, MixpanelEvents } from "../services/Mixpanel";
import { sendToLSQ } from "../services/LeadSquared";

// seo
import Seo from "../components/Seo";

// constants
import constant from "../constants";

// custom hooks
import { useCommonPageTracking } from "../hooks/usePageTracking";

// images
import bannerImg from "../images/forInsurer/banner.png";

// components
import Banner from "../components/Banner";
import InsurancePartner from "../components/ForInsurers/InsurancePartner";
import PrecisionCare from "../components/ForInsurers/PrecisionCare";
import PartnerTrust from "../components/ForInsurers/PartnerTrust";
import HealthPartner from "../components/ForInsurers/HealthPartner";
import DataPrivacy from "../components/ForInsurers/DataPrivacy";
import PartnerFormComponent from "../components/ForInsurers/PartnerForm";
import LogoCarouselComponent from "../components/Global/LogoCarousel/LogoCarousel";
import FaqComponent from "../components/Home/Faq/Faq";

const ForInsurersPage = props => {
  const [loading, setLoading] = useState(false);
  const formSectionRef = useRef(null);

  // Use common page tracking hooks
  const { deviceType, operatingSystem } = useCommonPageTracking(
    "For Insurers Page",
    props.location.search
  );

  // Mixpanel Events -> Cta Click events
  const handleMixpanelCTA = (ctaText, ctaLocation) => {
    Mixpanel.track(MixpanelEvents.contact_button_clicked, {
      page_name: "For Insurers Page",
      asset: "India Website",
      asset_name: "India Corporate Website",
      cta_text: ctaText,
      cta_location: ctaLocation,
    });
  };

  // Mixpanel Events -> FAQ Click Events
  const handleMixpanelCTAFaq = (faqText, faqDesc) => {
    Mixpanel.track(MixpanelEvents.faq_clicked, {
      page_name: "For Insurers Page",
      asset: "India Website",
      asset_name: "India Corporate Website",
      faq_text: faqText,
      faq_desc: faqDesc,
      faq_location: "For Insurers Page - FAQ Clicked",
    });
  };

  // Scroll to form section
  const scrollToForm = () => {
    if (formSectionRef.current) {
      formSectionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  // Handle form submission
  const handleFormSubmit = async formData => {
    setLoading(true);
    // leadSquared params
    let leadSquaredParams = {
      FirstName: formData.fullName,
      Phone: formData.mobileNumber,
      EmailAddress: formData.emailId,
      Notes: formData.organizationName,
      mx_Website_CTA: "for-insurers-page",
      mx_Latest_Source: "New Website",
      mx_Device_Mobile_Desktop: deviceType,
      mx_msc_Operating_System: operatingSystem,
    };

    await sendToLSQ(leadSquaredParams);
    setLoading(false);
  };

  return (
    <>
      <Seo
        title="For Insurers | Healthier Members, Lower Claims"
        description="Help your members get healthier and bring claims down. Partner with Twin Health India's proven, data-safe metabolic care program. See how it works."
      />
      <Banner
        pageName="For Insurance"
        title="Insurance Partners in India for Better Member Health & Lower Claims"
        description="AI-driven precision health helps insurers improve member health outcomes, reduce claims, and build sustainable insurance partnerships."
        ctaText="Partner with Twin Health"
        bannerImage={bannerImg}
        imageHeight="566px"
        imageWidth="518px"
        ctaLink=""
        onCtaClick={() => {
          handleMixpanelCTA(
            "Partner with Twin Health",
            "For Insurers Page - Banner Section"
          );
          scrollToForm();
        }}
      />

      <InsurancePartner />

      <PrecisionCare />

      <PartnerTrust />

      <HealthPartner />

      <DataPrivacy />

      <PartnerFormComponent
        ref={formSectionRef}
        onFormSubmit={handleFormSubmit}
        mixpanelPageName="For Insurers Page"
        loading={loading}
        deviceType={deviceType}
        operatingSystem={operatingSystem}
      />

      <LogoCarouselComponent
        title="Trusted by leading companies"
        backgroundColor="#FFFFFF"
      />

      <FaqComponent
        title="Frequently Asked Questions"
        accordionPayload={constant.FOR_INSURERS_PAGE_FAQ}
        onCtaClick={(faqText, faqDesc) =>
          handleMixpanelCTAFaq(faqText, faqDesc)
        }
      />
    </>
  );
};

export default ForInsurersPage;
